<template>
  <p-container>
    <p-row column spacious>
      <p-col>
        <h3 class="mb-2">
          {{ $t('core.page.error404.page.title') }}
        </h3>
        <p-alert class="mb-5" type="error" :value="true">
          {{ $t('core.page.error404.alert.pageCouldNotBeFound') }}
        </p-alert>
        <p-button @click="goToMainPage">
          {{ $t('core.page.error404.button.gotToMainPage') }}
        </p-button>
      </p-col>
    </p-row>
  </p-container>
</template>

<script lang="ts">
  import Vue from 'vue';

  export default Vue.extend({
    layout: 'layout-error-404',
    data: () => ({
    }),
    methods: {
      goToMainPage() {
        this.$router.push('/');
      },
    },
  });
</script>
